import type { FC } from 'react';
import type { ValidateResult } from 'react-hook-form';

import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { comparisonValidatorFunction } from '@/services/validators';

export function withFieldComparisonValidation( WrappedComponent: FC<ValidatedComponentProps> ) {
	const NewComponent = ( props: ValidatedComponentProps ) => {
		const { question, validators } = props;
		const { isRequired } = question;

		const { getValues } = useFormContext();

		const comparisonValidators = useMemo( () => {
			return validators.filter( validator => validator.fieldType === 'FieldComparison' );
		}, [ validators ] );

		const validationObject = useMemo( () => {
			const returnValue: Record<string, ( v: string ) => ValidateResult> = { ...question.validate };

			comparisonValidators.forEach( ( validator, index ) => {
				returnValue[ `comparison${ index }` ] = ( v: string ) => {
					return comparisonValidatorFunction( question, validator as ValidationFieldComparison, v, isRequired, getValues );
				};
			});

			return returnValue;
		}, [ comparisonValidators, getValues, isRequired, question ] );

		return (
			<WrappedComponent
				{ ...props }
				question={{
					...question,
					validate: validationObject
				}}
			/>
		);
	};

	NewComponent.displayName = 'withFieldComparisonValidators';

	return NewComponent;
}
